import React from 'react';
import { Send } from 'lucide-react';

const ContactForm = ({ formData, isSubmitting, onSubmit, onChange }) => {
  return (
    <form onSubmit={onSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">Full Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={onChange}
          placeholder="Your full name"
          required
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="email">Email Address</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={onChange}
          placeholder="you@company.com"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={onChange}
          placeholder="+91 98765 43210"
          data-testid="contact-phone-input"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="website">Website URL</label>
        <input
          type="text"
          id="website"
          name="website"
          value={formData.website}
          onChange={onChange}
          placeholder="yourwebsite.com"
          data-testid="contact-website-input"
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="challenge">Biggest Growth Challenge</label>
        <textarea
          id="challenge"
          name="challenge"
          value={formData.challenge}
          onChange={onChange}
          placeholder="Describe your #1 growth bottleneck — low ROAS, poor attribution, scaling paid spend, AI integration…"
          rows="4"
          required
        ></textarea>
      </div>
      
      <button type="submit" className="form-submit" disabled={isSubmitting} data-testid="contact-submit-btn">
        {isSubmitting ? 'Sending...' : 'Send Message'}
        <Send size={18} />
      </button>
    </form>
  );
};

export default ContactForm;
